import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  Tooltip,
  Modal,
  Row,
  Col,
  Typography,
  Button,
  Descriptions,
  Form,
  Input,
  Select,
  notification,
  Upload,
  Tag,
  message,
} from "antd";
// import { MdConnectWithoutContact } from "react-icons/md";
import { postReq } from "../api";
import { toastNotification } from "../utils/toasthelper";
import useUserDetails from "../utils/useUserDetails";
import moment from "moment";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import {
  LinkedinOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import AddOutreachModal from "../components/addOutreachModel";
import { useHistory, useParams } from "react-router-dom";
import CreateSpocModal from "../components/addSpocModel";
const { Title, Text } = Typography;
const { Option } = Select;

const JobCompanyView = () => {
  const location = useLocation();
  const { id } = useParams();
  console.log("id", id);
  // const { record } = location.state || {};
  const history = useHistory();
  const [company, setComapny] = useState("");
  const [data, setData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedSpoc, setSelectedSpoc] = useState(null);
  const [openSpocModal, setOpenSpocModal] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const formatFullAddress = (location = {}) => {
    if (!location) return { location: "-", requirementType: "Remote" };

    const { locality, city, state, country, displayText } = location;

    const parts = [
      locality,
      city,
      state,
      country === "IN" ? "India" : country,
    ].filter(Boolean);

    // Fallback if everything is empty
    if ((!parts.length || parts.length == 1) && displayText) {
      return { location: displayText, requirementType: "Remote" };
    }

    return { location: parts.join(", "), requirementType: "Onsite" };
  };

  const statusColorMap = {
    Pending: "orange",
    IN_DISCUSSION: "green",
    REPLIED: "blue",
    NOT_INTERESTED: "red",
    NO_REPLY: "gold",
  };
  const columns = [
    // {
    //   title: "Action",
    //   key: "action",
    //   render: (_, record) => (
    //     <div
    //       style={{
    //         cursor: "pointer",
    //         display: "flex",
    //         alignItems: "center",
    //         gap: "10px",
    //       }}
    //     >
    //       {(userData?.userRole == "company" ||
    //         userData?.permissions?.includes("client_details")) && (
    //         <Tooltip title="View Detail">
    //           <svg
    //             width="24"
    //             height="16"
    //             viewBox="0 0 30 24"
    //             fill="none"
    //             xmlns="http://www.w3.org/2000/svg"
    //             onClick={() => handleClick(record)}
    //           >
    //             <path
    //               fill-rule="evenodd"
    //               clip-rule="evenodd"
    //               d="M14.2818 0.0159601C7.45391 0.319947 1.70525 4.93397 0.109432 11.136C0.03645 11.4196 0 11.7099 0 12C0 12.2901 0.0364637 12.5804 0.109432 12.864C1.68348 18.9815 7.29798 23.554 14.0032 23.9692C14.3329 23.9896 14.6654 24 15 24C22.14 24 28.2391 19.2824 29.8906 12.864C29.9636 12.5804 30 12.2901 30 12C30 11.7099 29.9636 11.4196 29.8906 11.136C28.2391 4.71767 22.14 0 15 0C14.7593 0 14.5199 0.00536006 14.2818 0.0159601ZM21.8182 12C21.8182 15.6819 18.7657 18.6667 15 18.6667C11.2345 18.6667 8.18186 15.6819 8.18186 12C8.18186 8.31811 11.2345 5.33333 15 5.33333C18.7657 5.33333 21.8182 8.31811 21.8182 12ZM15 16C17.2594 16 19.0909 14.2092 19.0909 12C19.0909 9.7908 17.2594 8 15 8C12.7407 8 10.9091 9.7908 10.9091 12C10.9091 14.2092 12.7407 16 15 16Z"
    //               fill="#13487D"
    //             />
    //           </svg>
    //         </Tooltip>
    //       )}
    //     </div>
    //   ),
    // },
    {
      title: "Job Id",
      dataIndex: "jobId",
      key: "jobId",
      render: (_, record) => {
        return (
          <a
            href={record?.source?.url || record?.row?.source_link || "#"}
            target="_blank"
            rel="noreferrer"
          >
            {/* {record?.source?.name || "-"} */}
            {record?.jobId || ""}
          </a>
        );
      },
    },
    {
      title: "ICP",
      dataIndex: "icp",
      key: "icp",
      render: (_, record) => {
        return (
          <div className="space-y-2">
            <p>{record.icp}</p>
          </div>
        );
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      //   render: (text) => <p>{text}</p>,
    },
    {
      title: "Contract Type",
      dataIndex: "employement",
      key: "contractType",
      render: (_, record) => `${record?.employment?.contractType || "-"}`,
    },
    {
      title: "Contract Time",
      dataIndex: "employement",
      key: "contractTime",
      render: (_, record) => `${record?.employment?.contractTime || "-"}`,
    },
    {
      title: "Remote Type",
      dataIndex: "employement",
      key: "contractTime",
      render: (_, record) =>
        `${formatFullAddress(record.location).requirementType || "-"}`,
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      render: (_, record) => {
        const location = formatFullAddress(record.location).location;
        return `${location}`;
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => <p>{moment(text).format("DD/MM/YYYY HH:mm")}</p>,
    },
  ];

  const columns2 = [
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <div>
          <Button
            type="link"
            disabled={record.status == "NOT_CONNECTED"}
            onClick={(e) => {
              e.stopPropagation();
              history.push({
                pathname: `/company/spoc`,
                state: {
                  record,
                },
              });
            }}
          >
            View
          </Button>
          <Button
            type="link"
            // disabled={record.status == "NOT_CONNECTED"}
            onClick={(e) => {
              // if (record.name) {
              //   toastNotification(
              //     "error",
              //     "This Edit is Not posible please contact developer",
              //   );
              //   return;
              // }
              setSelectedSpoc(record);
              setIsEdit(true);
            }}
          >
            Edit
          </Button>
        </div>
      ),
    },
    {
      title: "Name",
      key: "name",
      render: (_, record) => (
        <>
          <Text>{record.name || `${record.firstName} ${record.lastName}`}</Text>
          <p>
            {record.region || null}{" "}
            {record.spocFrom ? `• ${record.spocFrom}` : null}
          </p>
        </>
      ),
    },
    {
      title: "Mobile",
      dataIndex: "phone",
      key: "phone",
      render: (text) => <p>{text || "-"}</p>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) => (
        <a
          //   href={`mailto:${text}`}
          href={`https://outlook.office.com/mail/deeplink/compose?to=${text}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#3699FF", textDecoration: "underline" }}
        >
          {text}
        </a>
      ),
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
    },
    {
      title: "Linked In",
      dataIndex: "linkedinUrl",
      key: "linkedinUrl",
      render: (text) => (
        <a
          //   href={`mailto:${text}`}
          href={`${text}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#3699FF", textDecoration: "underline" }}
        >
          <LinkedinOutlined style={{ fontSize: 22 }} />
        </a>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => <Tag color={statusColorMap[text]}>{text}</Tag>,
    },
    {
      title: "Outreach",
      key: "outreach",
      render: (_, record) => (
        <Button
          type="secondary"
          // icon={<PlusOutlined />}
          onClick={() => {
            setOpenModal(true);
            setSelectedSpoc(record._id);
          }}
          disabled={record.status !== "NOT_CONNECTED"}
        >
          <PlusOutlined />
          {/* <MdConnectWithoutContact /> */}
        </Button>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => <p>{moment(text).format("DD/MM/YYYY HH:mm")}</p>,
    },
  ];
  const [loading, setLoading] = useState(false);

  const [fileList, setFileList] = useState(null);
  const [tableParams, setTableParams] = useState({
    page: 1,
    limit: 20,
    search: "",
  });

  const userData = useUserDetails();
  const userRole = localStorage.getItem("userRole");

  const handleClick = (record) => {};
  const fetchData = async () => {
    setLoading(true);
    setSelectedSpoc(null);
    try {
      let results;
      results = await postReq(`common/list_job_company/${id}`);
      if (results.status === 1) {
        setData(results?.data);
        setComapny(results.data?.company);
        // setTotal(results.meta.total);
        setLoading(false);
      } else {
        setComapny("");
        setLoading(false);
      }
    } catch (error) {
      toastNotification("error", error.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(timeout);
  }, [tableParams.search, tableParams.page, tableParams.limit]);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams((prev) => ({
      ...prev,
      page: pagination.current,
      limit: pagination.pageSize,
    }));

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  const handleOnChange = (e) => {
    setTableParams((prev) => ({ ...prev, search: e.target.value }));
  };

  const handleUploadExcel = async (file) => {
    try {
      const formData = new FormData();
      formData.append("excel", file);
      const res = await postReq("common/upload_spoc_bulk", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "blob",
      });
      // download excel
      const blob = new Blob([res], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "spoc_import_result.xlsx";
      document.body.appendChild(link);
      link.click();

      link.remove();

      notification.success({
        message: "Import Completed",
        description: "Excel downloaded with status & remarks",
        placement: "topRight",
      });
    } catch (error) {
      notification.error({
        message: "Upload Failed",
        description: "Something went wrong",
        placement: "topRight",
      });
    }
  };

  return (
    <>
      <Card
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              borderRadius: "20px 20px 0px 0px",
              margin: "0px -24px",
            }}
          >
            <div>
              <Title
                level={4}
                style={{
                  marginBottom: 0,
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#13487D",
                }}
              >
                {company?.name || ""}
              </Title>
            </div>

            <div style={{ display: "inline-flex", gap: "8px" }}>
              <Upload
                accept=".csv,.xls,.xlsx"
                fileList={fileList}
                maxCount={1}
                beforeUpload={() => false} // prevent auto upload
                onChange={(info) => {
                  const newFileList = info.fileList.slice(-1);
                  setFileList(newFileList);

                  const file = newFileList[0]?.originFileObj;
                  if (file) {
                    handleUploadExcel(file);
                  }
                }}
              >
                <Button icon={<UploadOutlined />}>Upload SPOC</Button>
              </Upload>
              <Button
                type="secondary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setOpenSpocModal(true);
                }}
              >
                Add Spoc
              </Button>
            </div>
          </div>
        }
        style={{
          paddingLeft: "16px",
          color: "#13487D",
          borderRadius: "18px",
          maxWidth: "100%",
          overflow: "hidden",
        }}
        bordered={false}
      >
        <div
          level={4}
          style={{
            marginBottom: 5,
            fontSize: "18px",
            fontWeight: "800",
            color: "#13487D",
          }}
        >
          SPOC Persons
        </div>
        <Table
          className="new-table"
          columns={columns2}
          dataSource={data?.spocs || []}
          pagination={false}
          loading={loading}
          scroll={{ x: "max-content" }}
          style={{ marginBottom: "20px" }}
        />
        <div
          level={4}
          style={{
            marginBottom: 5,
            fontSize: "18px",
            fontWeight: "800",
            color: "#13487D",
          }}
        >
          ICP Jobs
        </div>
        <Table
          columns={columns}
          dataSource={data?.icpJobs || []}
          pagination={false}
          loading={loading}
          scroll={{ x: "max-content" }}
        />
      </Card>
      <AddOutreachModal
        open={openModal}
        spocId={selectedSpoc}
        onClose={() => setOpenModal(false)}
        onSuccess={fetchData}
      />
      <CreateSpocModal
        open={openSpocModal}
        onClose={() => setOpenSpocModal(false)}
        companyId={id || null}
        onSuccess={fetchData}
      />
      <CreateSpocModal
        open={isEdit}
        onClose={() => {
          setSelectedSpoc(null);
          setIsEdit(false);
        }}
        companyId={id || null}
        isEdit={isEdit}
        initialValues={selectedSpoc}
        onSuccess={fetchData}
      />
    </>
  );
};

export default JobCompanyView;
